<template>
  <div class="clock">
      {{ time | formatDate('HH:mm:ss UTC')}}
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'Clock', 
})
export default class Clock extends Vue {  
  time = new Date()  
  timerID = -1

  /*Cycle de vie*/
  created() {     
    this.timerID = setInterval(this.updateTime, 1000);                 
  }

  beforeDestroy() {
    clearInterval(this.timerID)
  }
  
  updateTime() {
    this.time = new Date();
  }
}
</script>

<style scope>
.clock {    
    color: #ffffff;        
    letter-spacing: 0.05em;    
}
</style>